import { LoaderPolicyRule } from '../models/loader-policy.models';

export const APP_LOADER_POLICY_RULES: LoaderPolicyRule[] = [
  {
    id: 'skip-refresh-token',
    enabled: true,
    match: {
      requestUrlIncludes: 'refreshToken',
    },
    resolve: {
      skip: true,
    },
    priority: 100,
  },
  {
    id: 'skip-heartbeat-requests',
    enabled: true,
    match: {
      requestUrlIncludes: 'heartbeat',
    },
    resolve: {
      skip: true,
    },
    priority: 110,
  },
  {
    id: 'skip-metrics-requests',
    enabled: true,
    match: {
      requestUrlIncludes: 'metrics',
    },
    resolve: {
      skip: true,
    },
    priority: 120,
  },
  {
    id: 'skip-polling-requests',
    enabled: true,
    match: {
      requestUrlIncludes: 'poll',
    },
    resolve: {
      skip: true,
    },
    priority: 130,
  },
  {
    id: 'skip-reminder-list-refresh',
    enabled: true,
    match: {
      requestUrlIncludes: 'getReminderList',
    },
    resolve: {
      skip: true,
    },
    priority: 140,
  },
  {
    id: 'ticket-details-route-default',
    enabled: true,
    match: {
      routePattern: '/tickets/details',
    },
    resolve: {
      mode: 'top-bar',
      scope: { type: 'route', key: 'ticket-details' },
      groupId: 'ticket-details-http',
    },
    priority: 220,
  },
];
